import StylePicker from './StylePicker';

export default StylePicker;